import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Tooltip
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CompanyUnits } from "../../../../../hooks/Remote/CompanyUnits/useRemoteFetchCompanyUnits";

interface Props {
  departmentData: CompanyUnits[] | undefined;
}

export function BottomToolbar({ departmentData }: Readonly<Props>) {
  const { t } = useTranslation();

  return (
    <Box
      sx={[
        theme => ({
          border: "1px solid #00000088",
          backgroundColor: "#ffffff",
          opacity: 0.95,
          position: "absolute",
          bottom: 10,
          m: 1,
          borderRadius: 2,
          ...theme.applyStyles("dark", { backgroundColor: "#000000" })
        })
      ]}
      data-testid="department-color-legend-container"
    >
      <TableContainer sx={{ minWidth: 200, maxWidth: 250 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" colSpan={2} sx={{ p: 0, py: 0.1 }}>
                {t("TableLegend")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "60%", p: 0, px: 2 }}>{t("Name")}</TableCell>
              <TableCell sx={{ width: "40%", p: 0, px: 2 }}>{t("Color")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {departmentData?.map(row => (
              <TableRow key={row.id}>
                <TableCell sx={{ px: 1.25, py: 1 }}>{row.name}</TableCell>
                <TableCell sx={{ px: 1.25, py: 1 }}>
                  <Tooltip title={row.color ?? t("No Color")}>
                    <Box
                      sx={{
                        background: row.color || "#D3D3D3",
                        width: "95%",
                        height: 12,
                        borderRadius: 1
                      }}
                    />
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
